var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowClockwise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5195 9.34695H21.0195V4.84695",
    stroke: "url(#paint0_linear_13_10220)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8321 17.8313C16.6786 18.9857 15.2086 19.7721 13.6081 20.091C12.0075 20.4099 10.3484 20.2469 8.84051 19.6227C7.33263 18.9984 6.04376 17.941 5.13694 16.5842C4.23012 15.2273 3.74609 13.632 3.74609 12C3.74609 10.368 4.23012 8.7727 5.13694 7.41585C6.04376 6.059 7.33263 5.00158 8.84051 4.37735C10.3484 3.75313 12.0075 3.59014 13.6081 3.90902C15.2086 4.22789 16.6786 5.0143 17.8321 6.16875L21.0196 9.34688",
    stroke: "url(#paint1_linear_13_10220)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_10220",
    x1: 11.3767,
    y1: 7.09695,
    x2: 19.7338,
    y2: 7.09695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01439B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1650FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13_10220",
    x1: -15.9951,
    y1: 12,
    x2: 16.0843,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01439B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1650FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowClockwise);
export default __webpack_public_path__ + "static/media/arrowClockwise.6a5da1bf7bf75d8a3aed3af24d25320a.svg";
export { ForwardRef as ReactComponent };